import ProductList from './ProductList.vue';
import ProductDetail from './ProductDetail.vue';
import ProductCreate from './ProductCreate.vue';
import ProductMetadata from './ProductMetadata.vue';
import { RouteRecordRaw } from 'vue-router';
import { databeheerder, systeembeheerder } from '@/core/security/roleTypes';

export const productRoutes: RouteRecordRaw = {
    path: '/product',
    name: 'product',
    redirect: '/product/list',
    meta: {
        hasRoles: [databeheerder, systeembeheerder],
    },
    children: [
        {
            path: '/product/list',
            name: 'product.list',
            component: ProductList,
            meta: {
                hasRoles: [databeheerder, systeembeheerder],
            },
        },
        {
            path: '/product/:id',
            name: 'product.detail',
            component: ProductDetail,
            meta: {
                hasRoles: [databeheerder, systeembeheerder],
            },
        },
        {
            path: 'create',
            name: 'product.create',
            meta: {
                hasRoles: [databeheerder, systeembeheerder],
            },
            component: ProductCreate,
        },
        {
            path: '/product/:id/metadata',
            name: 'product.metadata',
            component: ProductMetadata,
            meta: {
                hasRoles: [databeheerder, systeembeheerder],
            },
        },
    ],
};
